import { render, staticRenderFns } from "./insertBank.vue?vue&type=template&id=6d98fc03"
import script from "./insertBank.vue?vue&type=script&lang=js"
export * from "./insertBank.vue?vue&type=script&lang=js"
import style0 from "./insertBank.vue?vue&type=style&index=0&id=6d98fc03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports